import axios from 'axios';
import { attachTokenRefresh } from '@/utils/authInterceptors';

// Yekai Base Report Service Configuration
export const Yekai_BASE_URL = process.env.VUE_APP_ENV === "production"
  ? "https://www.vibrant-america.com/lisapi/v1/lis/base-report-service/" // production
  : "https://www.vibrant-america.com/lisapi/v1/lis/base-report-service/"; // development

const reportService = axios.create({
  baseURL: Yekai_BASE_URL
});

// Request interceptor to add authentication token
reportService.interceptors.request.use(
  async function (config) {
    let token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
reportService.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.error('Report Service API Error:', error);
    return Promise.reject(error);
  }
);

// Local Report Service Configuration (VW Page API)
const LOCAL_REPORT_BASE_URL_PROD = 'https://www.vibrant-america.com/lisapi/v1/lis/vw-page/v1/webpage/';
const LOCAL_REPORT_BASE_URL_STAGING = 'https://www.vibrant-america.com/lisapi/v1/lis/vw-page/v1/webpage/staging/';
const LOCAL_REPORT_BEARER_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNjk2OTk5OTk5fQ.9j7CYjUvXFDaZszPVDDbidm54ktwhy-FgEWrjegiORM';

export const LOCAL_REPORT_BASE_URL = process.env.VUE_APP_ENV === "production"
  ? LOCAL_REPORT_BASE_URL_PROD
  : LOCAL_REPORT_BASE_URL_STAGING;

export const localReportService = axios.create({
  baseURL: LOCAL_REPORT_BASE_URL,
  headers: {
    Authorization: `Bearer ${LOCAL_REPORT_BEARER_TOKEN}`
  }
});

// Request interceptor to ensure Bearer token is always set
localReportService.interceptors.request.use(
  async function (config) {
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${LOCAL_REPORT_BEARER_TOKEN}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
localReportService.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.error('Local Report Service API Error:', error);
    return Promise.reject(error);
  }
);

// localReportService intentionally omitted — it uses a hardcoded static bearer
// token, not the portal access token, so it needs no on-demand refresh.
attachTokenRefresh(reportService);

export default reportService;
